import React from 'react';

import Icon from '../Icon/Icon';

const TobaccoIcon = (props) => {
    return (
        <Icon width='48' height='48' fill='none' {...props}>
            <g clipPath='url(#4ijbepct7a)'>
                <mask id='za233r9ceb' maskUnits='userSpaceOnUse' x='2' y='15' width='45' height='31'>
                    <path
                        d='M24.52 44.042 6.423 40.5c-2.313-7.993-3.47-12.088-3.47-12.284 0-.195.367-4.357 1.1-12.486l4.242 1.52 5.01 2.704 2.777 2.171V30l2.688 5.314L23 39.99h1.52l2.063-.831 4.667-5.214 2.03-6.688V24l-.323-2.293 2.204-5.977 6.114 1.52c3.492 8.254 5.238 12.594 5.238 13.02 0 .425-4.672 5.495-14.015 15.211l-7.978-1.439z'
                        fill='#fff'
                    />
                </mask>
                <g mask='url(#za233r9ceb)'>
                    <path
                        clipRule='evenodd'
                        d='M28.265 27.947a14.578 14.578 0 0 1 12.322-5.195c1.179 4.399.23 9.293-2.938 13.07a14.574 14.574 0 0 1-13.003 5.125c-4.87.587-9.704-1.086-13.021-4.853-3.312-3.952-4.306-8.717-3.28-13.035a13.363 13.363 0 0 1 6.494.68c2.24.821 4.289 2.246 5.935 4.208a14.666 14.666 0 0 1 2.791 5.112l.958 3.104.954-3.105a14.623 14.623 0 0 1 2.788-5.11z'
                        stroke='#34303D'
                        strokeWidth='1.5'
                    />
                </g>
                <path
                    clipRule='evenodd'
                    d='M24.427 11.966a15.53 15.53 0 0 1 6.318 5.623 15.97 15.97 0 0 1 2.505 8.635c0 3.179-.912 6.14-2.484 8.623a15.694 15.694 0 0 1-6.265 5.672 15.696 15.696 0 0 1-6.267-5.67 16.075 16.075 0 0 1-2.484-8.625c0-3.163.903-6.11 2.46-8.586a15.7 15.7 0 0 1 6.216-5.672z'
                    stroke='#34303D'
                    strokeWidth='1.5'
                />
                <path
                    d='M24.5 16.875V40.5M20.375 28.875l4.125 5.07M20.375 22.125l4.125 5.07M28.645 28.875l-4.125 5.07M28.645 22.125l-4.125 5.07'
                    stroke='#34303D'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M35.806 18.082a16.426 16.426 0 0 0-7.247-8.516'
                    stroke='#00D1D2'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                />
                <path d='M24.5 9a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z' fill='#00D1D2' />
            </g>
            <defs>
                <clipPath id='4ijbepct7a'>
                    <path fill='#fff' transform='translate(.5)' d='M0 0h48v48H0z' />
                </clipPath>
            </defs>
        </Icon>
    );
};

export default TobaccoIcon;
